export default __webpack_public_path__ + "static/media/logo-child2.2ad731ab.svg";